import {
  ContainerPositionType,
  EquipmentDto,
  EquipmentForTallymanSelectionDto,
  EquipmentsApi,
} from '@operations/app/api'
import { WorkInstructionUpsertedEventPayload } from '@operations/app/api/signalRDtos/workInstructionUpsertedEventPayload'
import { createApiClient } from '@operations/app/http-client'
import { EventTypes } from '@operations/messages/eventsTypes'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import { action, makeObservable, observable } from 'mobx'

export class TallymanOperationsUIStore {
  selectedEquipmentId?: number
  selectedContainerPosition?: ContainerPositionType
  vesselVisitId?: number
  craneId?: number
  items: EquipmentForTallymanSelectionDto[] = []
  canCheckInContainer: boolean = false
  selectedOrderId?: number

  constructor(private readonly messageBus: IMessageBus) {
    makeObservable(this, {
      items: observable,
      selectedEquipmentId: observable,
      selectedContainerPosition: observable,
      vesselVisitId: observable,
      craneId: observable,
      canCheckInContainer: observable,
      selectedOrderId: observable,

      loadBy: action,
      selectEquipment: action,
      selectContainerPosition: action,
      confirmSelectedEquipment: action,
      setSelectedOrderId: action,
    })

    this.messageBus.subscribeEvent<EquipmentDto>(EventTypes.EquipmentUpserted, () => this.refresh())

    this.messageBus.subscribeEvent<number>(EventTypes.EquipmentDeleted, () => this.refresh())

    this.messageBus.subscribeEvent<WorkInstructionUpsertedEventPayload>(
      EventTypes.WorkInstructionUpserted,
      this.handleWorkInstructionUpserted,
    )
  }

  public setCanCheckInContainer(value?: boolean) {
    this.canCheckInContainer = !!value
  }

  public setSelectedOrderId(id?: number) {
    this.selectedOrderId = id
  }

  public selectEquipment(id?: number): void {
    this.selectedEquipmentId = id
  }

  public selectContainerPosition(position?: ContainerPositionType): void {
    this.selectedContainerPosition = position
  }

  private async refresh() {
    if (!this.vesselVisitId) return

    const { data } = await createApiClient(EquipmentsApi).getForTallymanOfDischarging(
      this.vesselVisitId,
      this.craneId,
    )

    this.items = data
  }

  public async loadBy(vesselVisitId: number, craneId?: number) {
    this.vesselVisitId = vesselVisitId
    this.craneId = craneId
    this.refresh()
  }

  public async confirmSelectedEquipment(
    carrierVisitId: number,
    orderId: number,
    selectedCraneId?: number,
    equipmentId?: number,
    selectedGangId?: number,
    containerPositionType?: ContainerPositionType,
  ) {
    await createApiClient(EquipmentsApi).assignToJobByTallyman({
      equipmentId: equipmentId,
      carrierVisitId: carrierVisitId,
      orderId: orderId,
      craneId: selectedCraneId,
      gangId: selectedGangId,
      containerPositionType,
    })
  }

  public async confirmCraneLoadingJob(
    orderId: number,
    selectedCraneId?: number,
    selectedGangId?: number,
  ) {
    await createApiClient(EquipmentsApi).tallymanConfirmCraneLoadingJob({
      orderId: orderId,
      craneId: selectedCraneId,
      gangId: selectedGangId,
    })
  }
  private handleWorkInstructionUpserted = async (
    res: IEvent<WorkInstructionUpsertedEventPayload>,
  ) => {
    if (res.payload?.workInstruction.externalOrderId === this.selectedOrderId) {
      this.setCanCheckInContainer(true)
    }
  }
}
